import { useTranslate } from '@ur-solutions/react-hooks'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import type { Tab} from '../../../../components_deprecated/Tabs';
import { TabPane, Tabs } from '../../../../components_deprecated/Tabs'
import EquipmentTab from '../components/EquipmentTab'
import MaterialsTab from '../components/MaterialsTab'

const Wrapper = styled.div`
  ${props => props.theme.layout.default};
`

interface FleetOverviewProps {}

export const FleetOverview: React.FC<FleetOverviewProps> = () => {
  const translations = useTranslate({
    equipment: 'common.equipment',
    materials: 'common.materials',
    title: 'vehicles.fleet-overview',
    addVehicle: 'vehicles.add-vehicle',
  })

  const tabs = useMemo<[Tab, Tab]>(
    () => [
      { key: 'equipment', text: translations.equipment },
      { key: 'materials', text: translations.materials },
    ],
    [translations]
  )
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0])

  return (
    <Wrapper>
      <Tabs
        activeTab={activeTab}
        tabs={tabs}
        onChange={tab => setActiveTab(tab)}
      />
      <TabPane active={activeTab.key === 'equipment'}>
        <EquipmentTab />
      </TabPane>
      <TabPane active={activeTab.key === 'materials'}>
        <MaterialsTab />
      </TabPane>
    </Wrapper>
  )
}
